<template>
    <v-container fluid>
        <customer-form
            :customer="customer"
            @saved="saved"
            type="create"
            :titlePrefix="$t('customer.create.texts.title-prefix')"
        ></customer-form>
    </v-container>
</template>

<script>
import CustomerModel from '@/models/Customer'
import CustomerForm from './Form'

export default {
    components: {
        'customer-form': CustomerForm,
    },

    data: () => {
        return {
            customer: new CustomerModel(),
        }
    },

    methods: {
        saved() {
            this.$router.push({ name: 'customer' })
        },
    },
}
</script>
